import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'routes/routes';

const HeaderLoginButton = () => {
   const { t } = useTranslation();
   const navigate = useNavigate();
   return (
      <Button
         onClick={() => navigate(routes().welcome)}
         sx={{
            backgroundColor: '#FFFFFF',
            py: 0.75,
            px: 1.5,
            width: 'fit-content',
            height: 'fit-content',
            maxWidth: 'unset',
            minWidth: 'unset',
            borderRadius: '99px',
            border: '1px solid #E5E5E5',
         }}
      >
         <Typography
            sx={{
               color: '#666666',
               fontSize: '12px',
               lineHeight: '14px',
               fontWeight: 600,
               whiteSpace: 'nowrap',
               textTransform: 'none',
            }}
         >
            Login
         </Typography>
      </Button>
   );
};

export default HeaderLoginButton;
